import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { auctionMembersType, auctionType, bidsType } from '../../types';
import BidsPlaceBidOpen from './BidsPlaceBidOpen';
import CreateButton from '../buttons/CreateButton';
import './_styles_/BidsPlaceBidRow.css';
import BidsPlaceBidSlotted from './BidsPlaceBidSlotted';
import {
    getBiddingType,
    OPEN,
} from '../../utils/BiddingTypes';
import WarningPanel from '../WarningPanel';

BidsPlaceBidRow.propTypes = {
    auction: auctionType.isRequired,
    auctionMembers: auctionMembersType.isRequired,
    isQuantityStepValid: PropTypes.bool.isRequired,
    quantityStep: PropTypes.number,
    isPriceStepValid: PropTypes.bool.isRequired,
    priceStep: PropTypes.number.isRequired,
    onBidAdded: PropTypes.func.isRequired,
    bids: bidsType.isRequired,
};

BidsPlaceBidRow.defaultProps = {
    quantityStep: null,
};

function BidsPlaceBidRow(props) {
    const {
        auction,
        auctionMembers,
        isQuantityStepValid,
        quantityStep,
        isPriceStepValid,
        priceStep,
        onBidAdded,
        bids,
    } = props;
    const { t } = useTranslation();
    const biddingType = getBiddingType(auction.biddingType);
    const [isPlaceBidVisible, setPlaceBidVisible] = useState(false);
    const actionHandler = () => setPlaceBidVisible(!isPlaceBidVisible);
    let result;
    if (auctionMembers.length) {
        result = (
            <>
                <CreateButton onAction={actionHandler} isCreateVisible={isPlaceBidVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('auctions.bids-list.place-bids')}</CreateButton>
                {isPlaceBidVisible
                    && (
                        biddingType.is(OPEN)
                            ? (
                                <BidsPlaceBidOpen
                                    auction={auction}
                                    auctionMembers={auctionMembers}
                                    isQuantityStepValid={isQuantityStepValid}
                                    quantityStep={quantityStep}
                                    isPriceStepValid={isPriceStepValid}
                                    priceStep={priceStep}
                                    onBidAdded={onBidAdded}
                                />
                            )
                            : (
                                <BidsPlaceBidSlotted
                                    auction={auction}
                                    auctionMembers={auctionMembers}
                                    isPriceStepValid={isPriceStepValid}
                                    priceStep={priceStep}
                                    onBidAdded={onBidAdded}
                                    bids={bids}
                                />
                            )
                    )}
            </>
        );
    } else {
        result = <WarningPanel message={t('auctions.bids-list.missing-member-warning')} />;
    }
    return (
        <div className="auction-bids--place-bid-row">
            {result}
        </div>
    );
}

export default BidsPlaceBidRow;
